import { isMobile } from "react-device-detect";
import MeuAdiantamentoHeader from "../MeuAdiantamentoHeader";
import { Divider, Row } from "antd";
import { useEffect, useState } from "react";
import MeuAdiantamento from "../MeuAdiantamento";
import { ReactComponent as Logo } from "shared/assets/images/contrato-assinado-icon.svg";
import { Trans, useTranslation } from "react-i18next";
import Duvidas from "../Duvidas";
import { useHistory } from "react-router-dom";
import {
  dataLayerViewedEvent,
  tagManagerEvent,
} from "event-tracker/gtm-events";
import { useSelector } from "react-redux";

const ContratoAssinado: React.FC<any> = ({ advance, reloadCashAdvance }) => {
  const [showMeuAdiantamento, setShowMeuAdiantamento] =
    useState<boolean>(false);
  const { t } = useTranslation();
  const history = useHistory();
  const { userArtist } = useSelector((state: any) => state.artists);

  const onClickHome = () => {
    history.push("/");
  };

  const onClickAvancar = () => {
    reloadCashAdvance();
  };

  useEffect(() => {
    if (userArtist.stage) {
      dataLayerViewedEvent({
        ...tagManagerEvent.Advance.S4A_SIGNATURE_CONFIRMED,
        proposalValue: advance?.totalAmountUsd,
        approvedLimit: userArtist?.cashAdvanceEstimated?.amountUsd,
        userTest: userArtist?.internalTest,
        carreerStage: userArtist?.stage,
        country: userArtist?.country,
      });
    }
  }, [userArtist, advance]);

  return (
    <div
      className="flex-column-between contrato-assinatura"
      style={{
        minHeight: isMobile ? "calc(100vh - 64px)" : "100vh",
        paddingLeft: isMobile ? 0 : 94,
      }}
    >
      <>
        <div
          className="migracao"
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <MeuAdiantamentoHeader
            setShowMeuAdiantamento={setShowMeuAdiantamento}
            showMeuAdiantamento={showMeuAdiantamento}
          />
          <Divider />
          {showMeuAdiantamento ? (
            <MeuAdiantamento advance={advance} />
          ) : (
            <>
              <div className="confirma-adiantamento-intro">
                <Logo />
                <h1 className="title">
                  {t("pages.Adiantamentos.contratoAssinadoTitulo")}
                </h1>
                <p
                  style={{ maxWidth: isMobile ? "unset" : 650 }}
                  className="texto"
                >
                  <>
                    <Trans
                      i18nKey={t("pages.Adiantamentos.contratoAssinadoTexto")}
                    />
                  </>
                </p>
              </div>
              <Row
                justify="center"
                style={{
                  flex: 1,
                  justifyContent: "flex-end",
                  alignItems: "center",
                  flexDirection: "column",
                  gap: 12,
                }}
              >
                <button
                  className="botao-roxo continuar"
                  onClick={onClickAvancar}
                >
                  {t("pages.Adiantamentos.avancar")}
                </button>
                <button className="botao-borda-roxa" onClick={onClickHome}>
                  {t("pages.Adiantamentos.botaoHome")}
                </button>
              </Row>
            </>
          )}
        </div>

        <div className="footer" style={{ paddingLeft: 8 }}>
          <Duvidas />
        </div>
      </>
    </div>
  );
};
export default ContratoAssinado;
